export const getVehicleStatus = (client, req) => client.rpc('service-mot', '1/2018-09-24/get_vehicle_status', req);
